import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import MyHome from '../views/My-Home.vue'
import Chat from '../views/Chat.vue'
import ResetPassword from '../views/Reset-Password.vue'
import MyAccount from '../views/My-Account.vue'
import PlatformAccount from '../views/Platform-Account.vue'

// 使用插件
Vue.use(Router)

const routers = [
  {
    name: "Login",
    path: "/login",
    component: Login
  },
  {
    name: "Home",
    path: "/home",
    component: Home
  },
  {
    name: "MyHome",
    path: "/myhome",
    component: MyHome
  },
  {
    name: "Chat",
    path: "/chat",
    component: Chat
  },
  {
    name: "ResetPassword",
    path: "/resetPassword",
    component: ResetPassword
  },
  {
    name: "MyAccount",
    path: '/myAccount',
    component: MyAccount,
  },
  {
    name: "PlatformAccount",
    path: '/platformAccount',
    component: PlatformAccount,
  }
  // {
  //   name: "system",
  //   path: "/system",
  //   children: [ // 通过children配置子级路由
  //       {
  //         path: '/myAccount',
  //         component: MyAccount,
  //       },
  //       {
  //         path: '/platformAccount',
  //         component: PlatformAccount,
  //       }
  //     ]
  // },
]

const router = new VueRouter({
  mode: 'history',
  routes: routers
})

export default router
